import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { Timer, ChevronRight } from "lucide-react";

export function ActiveTestView({
  activeTest,
  currentQuestion,
  setCurrentQuestion,
  answers,
  setAnswers,
  timeRemaining,
  formatTime,
  onSubmitAnswer
}) {
  const question = activeTest.questions?.[currentQuestion];
  const progress = ((currentQuestion + 1) / activeTest.num_questions) * 100;
  const isLowTime = timeRemaining < 60;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 text-white">
      {/* Test Header */}
      <header className="bg-slate-800/50 border-b border-slate-700 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Badge variant="outline" className="border-emerald-500 text-emerald-400">
                {activeTest.subject}
              </Badge>
              <span className="text-sm text-slate-400">
                Q {currentQuestion + 1} of {activeTest.num_questions}
              </span>
            </div>
            <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${isLowTime ? "bg-red-500/20 text-red-400" : "bg-emerald-500/20 text-emerald-400"}`}>
              <Timer className="w-4 h-4" />
              <span className="font-mono font-bold">{formatTime(timeRemaining)}</span>
            </div>
          </div>
          <Progress value={progress} className="mt-3 h-2" />
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        {question && (
          <Card className="bg-slate-800/50 border-slate-700">
            <CardContent className="pt-8 pb-8">
              <h2 className="text-xl font-semibold mb-8 text-white leading-relaxed">
                {question.question}
              </h2>
              
              <div className="space-y-3">
                <textarea
                  className="w-full h-32 bg-slate-700/50 border border-slate-600 rounded-lg p-4 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                  placeholder="Type your answer here..."
                  value={answers[currentQuestion] || ""}
                  onChange={(e) => setAnswers({ ...answers, [currentQuestion]: e.target.value })}
                  data-testid="answer-input"
                />
                
                <div className="flex gap-3 justify-end">
                  {currentQuestion > 0 && (
                    <Button
                      variant="outline"
                      className="border-slate-600 text-slate-300"
                      onClick={() => setCurrentQuestion(currentQuestion - 1)}
                    >
                      Previous
                    </Button>
                  )}
                  <Button
                    className="bg-emerald-600 hover:bg-emerald-700"
                    onClick={() => onSubmitAnswer(answers[currentQuestion] || "")}
                    disabled={!answers[currentQuestion]}
                    data-testid="submit-answer-btn"
                  >
                    {currentQuestion === activeTest.num_questions - 1 ? "Finish Test" : "Next"}
                    <ChevronRight className="w-4 h-4 ml-1" />
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        )}
      </main>
    </div>
  );
}

export default ActiveTestView;
